import React from 'react';
import styled from 'styled-components';
import { PhoneEnterSection } from 'pages/landing/PhoneEnterSection';
import { CodeEnterSection } from 'pages/landing/CodeEnterSection';
import { useSelector } from 'react-redux';
import { getGuestUserState } from 'modules/selectors/guestUser';
import { detectMob } from 'modules/utils/dom';
import bg from 'assets/img/landing/guest-login-bg.png';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background: #000 url(${ bg }) no-repeat;
	background-size: cover;
`;

interface IProps {
	visible?: boolean;
}

export const GuestEnterSection: React.FC<IProps> = ({visible}) => {
	const { showCodeVerify } = useSelector( getGuestUserState );
	const isMobile = detectMob();
	const isVisible = isMobile && visible;

	return isVisible ? (
		<Wrapper>
			{ !showCodeVerify ? <PhoneEnterSection/> : <CodeEnterSection/> }
		</Wrapper>
	) : null;
}
